// Only selection/search list DTOs use this boundary. A denied read may omit
// every collection; keep its business result for the existing failure UI.
export function selectionResponseError(data, collections) {
    if (Number.isInteger(data?.Result?.ReturnCode) && data.Result.ReturnCode !== 1) {
        return data;
    }
    if (data?.Result?.ReturnCode !== 1 || collections.some(name =>
        !Array.isArray(data[name]) || data[name].some(row =>
            !row || typeof row !== 'object' || Array.isArray(row)))) {
        return { errorMessage: 'Invalid selection response', malformedResponse: true };
    }
    return null;
}

// Saved offer DTOs have an identity and an ISO date. Never turn absent/null
// dates into an epoch/default date, or let calendar rollover invent a value.
export function savedSelectionOfferAvailable(row) {
    if (!Number.isInteger(row?.Id) || row.Id <= 0 || typeof row.OfferDate !== 'string' ||
        !/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(row.OfferDate) || !Number.isFinite(Date.parse(row.OfferDate))) return false;
    const day = row.OfferDate.slice(0, 10);
    return new Date(day + 'T00:00:00Z').toISOString().slice(0, 10) === day;
}
